/**
* =========================================================================================
* Component - Filter Header Responsive
* =========================================================================================
* 
**/

import React from 'react';
import * as Icon from 'ubs-icons';
import {COLOR} from "../../constant";
import {getFiltersLen} from "../../function";
import UBadge from "../../../UBadge";

const FilterHeaderResp = ({getFilter, filters}) => {

    return (
        <React.Fragment>
            <div className="u_filter-content-header">
                <div className="u_flex-align">
                    <h5 className="u_mr-8">Filter</h5>
                    {getFiltersLen(filters) !== 0 && <UBadge count={getFiltersLen(filters)} />}
                </div>
                <span className="u_icon-rollover u_icon-rollover-active u_ml-10 u_cp" onClick={() => getFilter(false)}>
                    <Icon.Close fill={COLOR?.u_blue} size={14}/>
                </span>
            </div> 
        </React.Fragment>
    )
}

export default FilterHeaderResp;
